export default __webpack_public_path__ + "static/media/blog.2fc0d84d.png";